






























































































































































































import { Component, mixins } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import BaseTooltip from '@/modules/shared/components/shared/kit/BaseTooltip.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import WriterBankAccountEditModal from '@/modules/bank-account/components/writer/WriterBankAccountEditModal.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
//TODO
import { PanelUserRoute } from '@/modules/user/routes/panel-user.route'
import { UserInfoSerializer } from '@/modules/user/serializer/user-info.serializer'
import { SerializerMixin } from '@/modules/shared/mixins/serializerMixin'
import { PanelUserService } from '@/modules/user/services/panel-user.service'

@Component({
  components: {
    BaseCard,
    BaseTooltip,
    BaseInput,
    BaseButton,
    Toggle,
    BankAccountEditModal: WriterBankAccountEditModal,
    Modal
  }
})
export default class WriterUserProfileInformation extends mixins<SerializerMixin<UserInfoSerializer>>(SerializerMixin) {
  constructor(
    private readonly routes: PanelUserRoute,
    private readonly service: PanelUserService
  ) {
    super()
  }

  @Prop() info!: any
  @Prop() telegramActivationLink!: string

  bankAccountModal = false

  telegramNotice = !!this.info.data.notification_preferences.telegram

  model = new UserInfoSerializer

  queryModel() {
    return {
      bank_account: this.info.data.bank_account[0]
    }
  }

  get withdrawPeriods() {
    return this.info.withdraw_periods
  }

  get bankNames() {
    return this.info.bank_names
  }

  updateNotificationPreferences(property, value) {
    this.service.updateNotificationPreferences({
      notifications: {
        [property]: value
      }
    })
  }
}
